import { render, staticRenderFns } from "./AddressCard.vue?vue&type=template&id=ab3aa5de&scoped=true&lang=pug&"
import script from "./AddressCard.vue?vue&type=script&lang=js&"
export * from "./AddressCard.vue?vue&type=script&lang=js&"
import style0 from "./AddressCard.vue?vue&type=style&index=0&id=ab3aa5de&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab3aa5de",
  null
  
)

export default component.exports